import React from 'react'
import TabUI from "../../../widgets/output/TabUI";
import TabLinkUI from "../../../widgets/output/TabLinkUI";

const LoanSubTabUI = ({context,
    onAccountsTabClick,
    onMetaTabClick,
    onLeegalityMappingsTabClick,
    tabSelected
  }) =>
  <div>
    <div>
      <TabLinkUI label='Loans' active={tabSelected === "loans"} to='/su/loans' />
      <TabUI label='Leegality' active={tabSelected === "leegality_mappings"} onClick={onLeegalityMappingsTabClick}/>
      <TabUI label='Scores' active={tabSelected === "score"} onClick={onAccountsTabClick}/>
      <TabUI label='Score metadata' active={tabSelected === "meta"} onClick={onMetaTabClick}/>
    </div>
    <div className='g_m_top_100' />
  </div>

export default LoanSubTabUI
